import { cn } from "@/lib/utils";
import { AsideProps, BlogLayoutProps, MainProps } from "@/types/blog-post";

const BlogLayout = ({ children }: BlogLayoutProps) => {
  return (
    <div className="container mx-auto">
      <section className="flex justify-between gap-12 md:flex-row flex-col pb-24 sm:pb-40">{children}</section>
    </div>
  );
};

const Aside = ({ children, isSticky = true }: AsideProps) => {
  return (
    <aside
      className={cn(
        "max-h-screen overflow-auto overscroll-contain flex-none w-full md:w-80",
        isSticky && "lg:sticky top-6"
      )}
    >
      {children}
    </aside>
  );
};

const Main = ({ children }: MainProps) => {
  return (
    <main className="max-w-full grow flex-basis-[737px] md:max-w-[737px] md:flex-basis-[100%]">{children}</main>
  );
};

BlogLayout.Aside = Aside;
BlogLayout.Main = Main;

export default BlogLayout;
